import $ from "jquery";

$(function initialize() {
  $(document).on('click', '[data-behavior="radio"] .radio-options li', function handleClick() {
    var $button = $(this);
      var $hiddenInput = $button.find('input');

    $hiddenInput.prop('checked', true).change();
    $button.addClass('selected').siblings().removeClass('selected');
  });
});
